/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import DescriptionField from "react-jsonschema-form/lib/components/fields/DescriptionField";
import {Checkbox} from 'react-icheck';
// import Checkbox from "../../../../components/Bootstrap/Checkbox";

class CheckboxWidget extends React.Component {
    static propTypes = {
        schema: PropTypes.object.isRequired,
        id: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        readonly: PropTypes.bool,
        autofocus: PropTypes.bool,
        onChange: PropTypes.func,
        options: PropTypes.shape({
            checkedValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
            uncheckedValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
        }).isRequired
    };

    static defaultProps = {
        autofocus: false
    };

    constructor(props) {
        super(props);
        this.state = {};
        this.onChange = this.onChange.bind(this);
    }

    isChecked(value) {
        let checkedValue = this.getCheckedValue();
        if (value === checkedValue) return true;

        let uncheckedValue = this.getCheckedValue();
        if (value === uncheckedValue) return false;

        if (value == checkedValue) return true;
        return false;
    }

    getCheckedValue() {
        if (this.props.options && _.has(this.props.options, "checkedValue") ) return this.props.options.checkedValue;
        switch (this.props.schema.type) {
            case "boolean":
                return true;
            case "number":
            case "integer":
                return 1;
            case "string":
            default:
                return "true";
        }
    }

    getUncheckedValue() {
        if (this.props.options && _.has(this.props.options, "uncheckedValue") ) return this.props.options.uncheckedValue;
        switch (this.props.schema.type) {
            case "boolean":
                return false;
            case "number":
            case "integer":
                return 0;
            case "string":
            default:
                return "false";
        }
    }

    onChange(e) {
        e.preventDefault();
        this.props.onChange(e.target.checked ? this.getCheckedValue() : this.getUncheckedValue());
    }

    render() {
        const {
            schema,
            id,
            required,
            disabled,
            readonly,
            label,
            value,
            autofocus,
            options
        } = this.props;

        return (
            <div className="i-checks">
                <div className={`checkbox ${disabled || readonly ? "disabled" : ""}`}>
                    {schema.description &&
                    <DescriptionField description={schema.description} />}
                    <Checkbox
                        id={id}
                        checkboxClass="icheckbox_square-green"
                        increaseArea="20%"
                        label={options.title || label}
                        checked={this.isChecked(value)}
                        required={required}
                        disabled={disabled || readonly}
                        autoFocus={autofocus}
                        onChange={this.onChange}
                    />
                </div>
            </div>
        );
    }
}

export default CheckboxWidget;
